
export const MAIL_API_URL = 'https://util.cruxbytes.com/mail-sending.aspx'

// Builds the HTML email body using the same %3C/%3E tag-encoding
// technique as the legacy CruxBytes script (decoded server-side).
export function buildEmailBody({ name, email, phone, message }) {
  const StartTag = '%3C'
  const EndTag = '%3E'
  const siteUrl = window.location.hostname

  return (
    StartTag + 'html' + EndTag +
    StartTag + 'body' + EndTag +
    StartTag + 'p' + EndTag + 'Dear '+name+',' + StartTag + '/p' + EndTag +
    StartTag + 'p' + EndTag + 'You have successfully submitted an enquiry with the following details:' + StartTag + '/p' + EndTag +
    StartTag + 'br /' + EndTag + StartTag + 'b' + EndTag + 'Enquiry From: ' + StartTag + '/b' + EndTag + name +
    StartTag + 'br /' + EndTag + StartTag + 'b' + EndTag + 'Email ID: ' + StartTag + '/b' + EndTag + email +
    StartTag + 'br /' + EndTag + StartTag + 'b' + EndTag + 'Contact No: ' + StartTag + '/b' + EndTag + phone +
    StartTag + 'br /' + EndTag + StartTag + 'b' + EndTag + 'Query/ Comments: ' + StartTag + '/b' + EndTag + message + StartTag + '/p' + EndTag +
    StartTag + 'p' + EndTag + 'This is a system generated email. Please do not reply.' + StartTag + '/p' + EndTag +
    StartTag + 'p' + EndTag + 'Warm Regards,' + StartTag + 'br' + EndTag +
    StartTag + 'a href=' + 'www.cruxbytes.com' + EndTag + 'CruxBytes Support' + StartTag + '/a' + EndTag + '.' + StartTag + '/p' + EndTag +
    StartTag + '/body' + EndTag +
    StartTag + '/html' + EndTag
  )
}
export function buildPartnerEmailBody({ name, company, email, mobile, interest }) {
  const StartTag = '%3C'
  const EndTag = '%3E'
  const siteUrl = window.location.hostname

  return (
    StartTag + 'html' + EndTag +
    StartTag + 'body' + EndTag +
    StartTag + 'p' + EndTag + 'Dear '+name+',' + StartTag + '/p' + EndTag +
    StartTag + 'p' + EndTag + 'You have successfully submitted a partnership enquiry with the following details:' + StartTag + '/p' + EndTag +
    StartTag + 'br /' + EndTag + StartTag + 'b' + EndTag + 'Name: ' + StartTag + '/b' + EndTag + name +
    StartTag + 'br /' + EndTag + StartTag + 'b' + EndTag + 'Company: ' + StartTag + '/b' + EndTag + company +
    StartTag + 'br /' + EndTag + StartTag + 'b' + EndTag + 'Email ID: ' + StartTag + '/b' + EndTag + email +
    StartTag + 'br /' + EndTag + StartTag + 'b' + EndTag + 'Mobile: ' + StartTag + '/b' + EndTag + mobile +
    StartTag + 'br /' + EndTag + StartTag + 'b' + EndTag + 'Interested In: ' + StartTag + '/b' + EndTag + interest + StartTag + '/p' + EndTag +
    StartTag + 'p' + EndTag + 'This is a system generated email. Please do not reply.' + StartTag + '/p' + EndTag +
    StartTag + 'p' + EndTag + 'Warm Regards,' + StartTag + 'br' + EndTag +
    StartTag + 'a href=' + 'www.cruxbytes.com' + EndTag + 'CruxBytes Support' + StartTag + '/a' + EndTag + '.' + StartTag + '/p' + EndTag +
    StartTag + '/body' + EndTag +
    StartTag + '/html' + EndTag
  )
}

export function buildCareerEmailBody({ name, email, mobile, applyingFor, heardAbout, resumeUrl }) {
  const StartTag = '%3C'
  const EndTag = '%3E'
  const siteUrl = window.location.hostname

  return (
    StartTag + 'html' + EndTag +
    StartTag + 'body' + EndTag +
    StartTag + 'p' + EndTag + 'Dear '+name+',' + StartTag + '/p' + EndTag +
    StartTag + 'p' + EndTag + 'You have successfully submitted a job application with the following details:' + StartTag + '/p' + EndTag +
   StartTag + 'br /' + EndTag + StartTag + 'b' + EndTag + 'Name: ' + StartTag + '/b' + EndTag + name +
    StartTag + 'br /' + EndTag + StartTag + 'b' + EndTag + 'Email ID: ' + StartTag + '/b' + EndTag + email +
    StartTag + 'br /' + EndTag + StartTag + 'b' + EndTag + 'Mobile: ' + StartTag + '/b' + EndTag + mobile +
    StartTag + 'br /' + EndTag + StartTag + 'b' + EndTag + 'Applying For: ' + StartTag + '/b' + EndTag + applyingFor +
    StartTag + 'br /' + EndTag + StartTag + 'b' + EndTag + 'Heard About Us: ' + StartTag + '/b' + EndTag + heardAbout +
    StartTag + 'br /' + EndTag + StartTag + 'b' + EndTag + 'Resume Link: ' + StartTag + '/b' + EndTag + (resumeUrl || 'Not provided') + StartTag + '/p' + EndTag +
    StartTag + 'p' + EndTag + 'This is a system generated email. Please do not reply.' + StartTag + '/p' + EndTag +
    StartTag + 'p' + EndTag + 'Warm Regards,' + StartTag + 'br' + EndTag +
    StartTag + 'a href=' + 'www.cruxbytes.com' + EndTag + 'CruxBytes Support' + StartTag + '/a' + EndTag + '.' + StartTag + '/p' + EndTag +
    StartTag + '/body' + EndTag +
    StartTag + '/html' + EndTag
  )
}

// Reads the ?res= query param that mail-sending.aspx appends when it
// redirects back after processing the form (1 = success, 2 = failure).
export function readEnquiryStatus() {
  const params = new URLSearchParams(window.location.search)
  console.log(params);
  const res = params.get('res')
  if (res === '1') return 'success'
  if (res === '2') return 'error'
  return null
}